module.exports = __webpack_public_path__ + "static/media/simunation-logo-transparent.1cc239de.png";